import React, { useContext } from 'react';
import { fetchConfig } from '../../products/services';
import Dialog from '../components/Dialog';
import { useDispatch } from 'react-redux';
import { TenantContext, UserContext } from '../../orbit-context';
import { useDialog } from '../../products/hooks/use-dialog';
import { useHistory } from 'react-router-dom';
interface SolutionContextValue {
  config: any;
  openDialog: any;
}

export const SolutionContext = React.createContext<SolutionContextValue>({} as SolutionContextValue);

const SolutionContextProvider: React.FC = (props) => {
  const { children } = props;
  const dispatch = useDispatch();
  const user = useContext(UserContext);
  const tenant = useContext(TenantContext);
  const history = useHistory();
  const [config, setConfig] = React.useState();
  const { visible, value, open, close } = useDialog();

  React.useEffect(() => {
    (async () => {
      try {
        const config = await fetchConfig(dispatch, user, tenant, 'zh');
        setConfig(config as any);
      } catch (error) {
        console.log('获取配置失败');
      }
    })();
  }, []);
  return <SolutionContext.Provider
    value={{
      config,
      openDialog: open
    }}
  >
    {config && children}
    {visible && value &&
      <Dialog
        // className={styles.dialog_component}
        config={config}
        style={{ zIndex: 6 }}
        data={value}
        pTitle={value?.a_name}
        context={'3d'}
        onDialogClose={close}
        history={history}
      />
    }
  </SolutionContext.Provider>;
};

export default SolutionContextProvider;

export const useSolutionContext = (): SolutionContextValue => React.useContext<SolutionContextValue>(SolutionContext);

export const connect = (Component: React.FC): React.FC => {
  // eslint-disable-next-line react/display-name
  return (props) => {
    return <SolutionContextProvider>
      <Component {...props} />
    </SolutionContextProvider>;
  };
};
